import bankAccountFragmentRawString from '../BankAccountFragment.graphql'

export const bankAccountFragmentString = bankAccountFragmentRawString

export type BankAccountFragment = {
  id: string
  bankName: string
  object: string
  last4: string
  accountHolderName: string
}

export const isBankAccountFragment = (
  fragment: any,
): fragment is BankAccountFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.bankName === 'string' &&
  typeof fragment.object === 'string' &&
  typeof fragment.last4 === 'string' &&
  typeof fragment.accountHolderName === 'string'
